export const profilePageStyles = {
  page: {
    paddingTop: 14,
  } as const,
  loadingPage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as const,
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 10,
  } as const,
  topDivider: {
    height: 2,
    margin: '0 -14px 8px',
    background: 'linear-gradient(90deg, rgba(111,115,246,0.5) 0%, rgba(111,115,246,0.22) 55%, rgba(111,115,246,0) 100%)',
  } as const,
  topBarLeft: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  } as const,
  topBarTitle: {
    fontSize: 17,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  topBarIconWrap: {
    width: 28,
    height: 28,
    borderRadius: 8,
    background: '#151821',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    boxShadow: '0 8px 18px rgba(21, 24, 33, 0.12)',
  } as const,
  settingsButton: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    border: '1px solid rgba(31, 35, 41, 0.08)',
    background: '#ffffff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#5d6474',
    boxShadow: '0 8px 18px rgba(31, 35, 41, 0.06)',
  } as const,
  heroCard: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 24,
    padding: '18px 16px 14px',
    background: 'linear-gradient(135deg, #6f73f5 0%, #8477f3 45%, #8b67ed 100%)',
    color: '#ffffff',
    boxShadow: '0 14px 28px rgba(112, 103, 239, 0.24)',
  } as const,
  heroGlowPrimary: {
    position: 'absolute',
    top: -32,
    right: -24,
    width: 132,
    height: 132,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 68%)',
    pointerEvents: 'none',
  } as const,
  heroGlowSecondary: {
    position: 'absolute',
    bottom: -44,
    left: -22,
    width: 148,
    height: 148,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%)',
    pointerEvents: 'none',
  } as const,
  heroTop: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  } as const,
  heroUserRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
    flex: 1,
  } as const,
  avatarWrap: {
    position: 'relative',
    width: 58,
    height: 58,
    flexShrink: 0,
  } as const,
  avatar: {
    width: 58,
    height: 58,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #eef2ff 0%, #ffffff 100%)',
    border: '2px solid rgba(255, 255, 255, 0.86)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 18px rgba(47, 52, 88, 0.16)',
    overflow: 'hidden',
  } as const,
  avatarStatusDot: {
    position: 'absolute',
    right: 0,
    bottom: 2,
    width: 13,
    height: 13,
    borderRadius: '50%',
    background: '#43d97b',
    border: '2px solid #ffffff',
    boxShadow: '0 6px 12px rgba(67, 217, 123, 0.22)',
  } as const,
  heroName: {
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#ffffff',
  } as const,
  heroUsername: {
    marginTop: 3,
    fontSize: 12,
    lineHeight: 1.3,
    color: 'rgba(255, 255, 255, 0.76)',
    fontWeight: 600,
  } as const,
  heroRoleBadge: {
    marginLeft: 6,
    display: 'inline-flex',
    alignItems: 'center',
    height: 18,
    padding: '0 7px',
    borderRadius: 999,
    background: 'rgba(255,255,255,0.22)',
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 700,
    verticalAlign: 'middle',
  } as const,
  heroCenterButton: {
    height: 28,
    padding: '0 11px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.14)',
    background: 'rgba(255,255,255,0.14)',
    color: '#ffffff',
    fontSize: 11,
    fontWeight: 700,
    backdropFilter: 'blur(10px)',
    boxShadow: 'none',
  } as const,
  heroDescription: {
    position: 'relative',
    zIndex: 1,
    marginTop: 18,
    fontSize: 13,
    lineHeight: 1.65,
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: 600,
  } as const,
  heroMetaRow: {
    position: 'relative',
    zIndex: 1,
    marginTop: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  } as const,
  heroMetaText: {
    fontSize: 11,
    lineHeight: 1.4,
    color: 'rgba(255, 255, 255, 0.88)',
    fontWeight: 700,
  } as const,
  summaryRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 8,
  } as const,
  summaryCard: {
    borderRadius: 16,
    padding: '14px 8px 12px',
    background: '#ffffff',
    border: '1px solid rgba(31, 35, 41, 0.05)',
    boxShadow: '0 8px 18px rgba(31, 35, 41, 0.05)',
    textAlign: 'center',
  } as const,
  summaryIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 12,
    margin: '0 auto 9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  summaryLabel: {
    fontSize: 11,
    lineHeight: 1.35,
    color: '#6c7383',
    fontWeight: 700,
    letterSpacing: '0.01em',
  } as const,
  summaryValue: {
    marginTop: 5,
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  summaryHint: {
    marginTop: 4,
    fontSize: 10,
    lineHeight: 1.35,
    color: '#a5adbd',
  } as const,
  pointsCard: {
    width: '100%',
    border: 'none',
    borderRadius: 18,
    padding: '16px',
    background: '#ffffff',
    boxShadow: '0 10px 24px rgba(31, 35, 41, 0.06)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    textAlign: 'left',
  } as const,
  pointsCardLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  } as const,
  pointsIconWrap: {
    width: 42,
    height: 42,
    borderRadius: 14,
    background: 'rgba(111, 115, 246, 0.10)',
    color: '#6f73f6',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } as const,
  pointsLabel: {
    fontSize: 12,
    lineHeight: 1.35,
    color: '#6c7383',
    fontWeight: 700,
  } as const,
  pointsValue: {
    marginTop: 3,
    fontSize: 24,
    lineHeight: 1.1,
    color: '#1f2430',
    fontWeight: 900,
  } as const,
  pointsAction: {
    minWidth: 82,
    height: 34,
    borderRadius: 999,
    background: '#eef2ff',
    color: '#5b61e6',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 800,
    flexShrink: 0,
  } as const,
  sectionWrap: {
    marginTop: 22,
  } as const,
  sectionHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 10,
  } as const,
  sectionTitle: {
    fontSize: 15,
    lineHeight: 1.25,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  sectionSubtitle: {
    marginTop: 3,
    fontSize: 11,
    lineHeight: 1.5,
    color: '#9198a8',
    fontWeight: 600,
  } as const,
  sectionLink: {
    border: 'none',
    background: 'transparent',
    color: '#7076f6',
    fontSize: 11,
    fontWeight: 700,
    padding: 0,
  } as const,
  infoCard: {
    borderRadius: 16,
    background: '#ffffff',
    border: '1px solid rgba(31, 35, 41, 0.05)',
    boxShadow: '0 8px 18px rgba(31, 35, 41, 0.05)',
    padding: 0,
    overflow: 'hidden',
  } as const,
  infoRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '15px 14px',
    background: '#ffffff',
    border: 'none',
    textAlign: 'left',
  } as const,
  infoIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 11,
    background: 'rgba(111, 115, 246, 0.10)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6f73f6',
    flexShrink: 0,
  } as const,
  infoRowContent: {
    minWidth: 0,
    flex: 1,
  } as const,
  infoLabel: {
    fontSize: 13,
    lineHeight: 1.3,
    fontWeight: 800,
    color: '#2a3040',
  } as const,
  infoHint: {
    marginTop: 3,
    fontSize: 10,
    lineHeight: 1.4,
    color: '#98a0b1',
    fontWeight: 600,
  } as const,
  infoValue: {
    fontSize: 13,
    lineHeight: 1.3,
    fontWeight: 700,
    color: '#2a3040',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  } as const,
  arrow: {
    color: '#8c94a5',
    fontSize: 16,
    lineHeight: 1,
    flexShrink: 0,
  } as const,
  quickList: {
    display: 'grid',
    gap: 10,
  } as const,
  quickRow: {
    width: '100%',
    borderRadius: 16,
    background: '#ffffff',
    border: '1px solid rgba(31, 35, 41, 0.05)',
    boxShadow: '0 8px 18px rgba(31, 35, 41, 0.05)',
    padding: '15px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    textAlign: 'left',
  } as const,
  quickIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 11,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } as const,
  quickTextWrap: {
    minWidth: 0,
    flex: 1,
  } as const,
  quickTitle: {
    fontSize: 13,
    lineHeight: 1.3,
    fontWeight: 800,
    color: '#2a3040',
  } as const,
  quickDescription: {
    marginTop: 3,
    fontSize: 10,
    lineHeight: 1.45,
    color: '#98a0b1',
    fontWeight: 600,
  } as const,
  quickValue: {
    fontSize: 12,
    lineHeight: 1.2,
    color: '#4e5565',
    fontWeight: 700,
    flexShrink: 0,
  } as const,
  logoutButton: {
    height: 42,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #ef4444 0%, #e8343d 100%)',
    border: 'none',
    color: '#ffffff',
    fontWeight: 800,
    boxShadow: '0 14px 26px rgba(232, 52, 61, 0.20)',
  } as const,
  versionText: {
    marginTop: 14,
    textAlign: 'center',
    fontSize: 10,
    lineHeight: 1.4,
    letterSpacing: '0.12em',
    color: '#b0b5c2',
    fontWeight: 700,
  } as const,
} as const;
